import { render, staticRenderFns } from "./checkbox-list.vue?vue&type=template&id=901b9b86&"
import script from "./checkbox-list.vue?vue&type=script&lang=js&"
export * from "./checkbox-list.vue?vue&type=script&lang=js&"
import style0 from "./_checkbox-list.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports